import { parseRichText, parseTermsContent } from '@chegg/commerce-utils';

/**
 * Interpolates the display price into sanitized and parsed terms
 * and conditions content from Contentful.
 * @param termsContent The terms and conditions from Contentful
 * @param price The price to the displayed in the terms and conditions
 */
export var tncStringManipulation = function tncStringManipulation(termsContent, price) {
  return parseTermsContent(parseRichText(termsContent), price);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/utils/TncStringManipulation.js
// module id = 1466
// module chunks = 11